import { useTranslation } from "react-i18next";

import { Step } from "components/Wizard/Step/Step";

import { AccountGroup } from "../PrivilegesTable/AccountGroup";
import { DatabasesGroup } from "../PrivilegesTable/DatabasesGroup";
import { EnginesGroup } from "../PrivilegesTable/EnginesGroup";
import { PrivilegesTable } from "../PrivilegesTable/PrivilegesTable";
import { RolesGroup } from "../PrivilegesTable/RolesGroup";
import { SchemasGroup } from "../PrivilegesTable/SchemasGroup";
import { TablesGroup } from "../PrivilegesTable/TablesGroup";
import { ViewsGroup } from "../PrivilegesTable/ViewsGroup";
import {
  ROLES_WIZARD_SET_EMPTY_SECTION_ERRORS,
  hasEmptySectionErrors,
} from "../privilegesReducer";
import { PrivilegesStepType } from "../types";
import { usePrivilegesState } from "../usePrivilegesContext";

type Props = {
  onClose: () => void;
  onSubmit: (data: PrivilegesStepType) => void;
  onPrevStep: () => void;
  activeStepIndex: number;
};

export const PrivilegesStep = (props: Props) => {
  const { onClose, activeStepIndex, onPrevStep, onSubmit } = props;
  const { t } = useTranslation();

  const sections = [
    {
      type: "account",
      title: t("roles_wizard.privileges.column_accounts"),
      Component: AccountGroup,
      headerAction: true,
    },
    {
      type: "engine",
      title: t("roles_wizard.privileges.column_engines"),
      Component: EnginesGroup,
      headerAction: true,
    },
    {
      type: "database",
      title: t("roles_wizard.privileges.column_databases"),
      Component: DatabasesGroup,
      headerAction: true,
    },
    {
      type: "schema",
      title: t("roles_wizard.privileges.column_schemas"),
      Component: SchemasGroup,
      headerAction: true,
    },
    {
      type: "table",
      title: t("roles_wizard.privileges.column_tables"),
      Component: TablesGroup,
      headerAction: true,
    },
    {
      type: "view",
      title: t("roles_wizard.privileges.column_views"),
      Component: ViewsGroup,
      headerAction: true,
    },
    {
      type: "role",
      title: t("roles_wizard.privileges.column_account_roles"),
      Component: RolesGroup,
      headerAction: true,
    },
  ];

  const { privilegesState, privilegesDispatch, validateEmptySections } =
    usePrivilegesState();

  const body = <PrivilegesTable sections={sections} />;

  const onFormSubmit = () => {
    const submit = {
      privileges: privilegesState,
    };
    const errors = validateEmptySections();
    if (hasEmptySectionErrors(errors)) {
      privilegesDispatch({
        type: ROLES_WIZARD_SET_EMPTY_SECTION_ERRORS,
        errors,
      });

      return;
    }
    onSubmit(submit);
  };

  return (
    <Step
      title={t("roles_wizard.privileges.title")}
      subtitle={t("roles_wizard.privileges.subtitle")}
      body={body}
      onClose={onClose}
      onSubmit={onFormSubmit}
      activeStepIndex={activeStepIndex}
      onPrevStep={onPrevStep}
      titleTestId="roles-wizard-privileges-title"
    />
  );
};
